import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import ReactPixel from 'react-facebook-pixel';
import { Link, useHistory, useParams } from "react-router-dom";
import FacebookLogin from "react-facebook-login";
import makeToast from "../toster/TosterMessage";
import { useSnackbar } from "react-simple-snackbar";
import OTPInput, { ResendOTP } from "otp-input-react";
import {
  AskOtpPassword,
  learnerLogin,
  Signup,
  VerifyOtpV1,
  Setpassword,
  SosialAuth,
  ResendOtpV1,
  AskOtpV1,
} from "../../redux/actions/AuthAction";
import "react-phone-number-input/style.css";
import PhoneInput from "react-phone-number-input";
import {
  parsePhoneNumber,
  getCountryCallingCode,
  isValidPhoneNumber,
} from "react-phone-number-input";
import { GoogleLogin } from 'react-google-login';
import { getDevice } from "../../helpers/PageHelper";

const FacebookAuth = ({ responseFacebook, btnLoder }) => {
  return (
    <FacebookLogin
      className="facebook_auth"
      appId="466853794740758"
      //"466853794740758"
      autoLoad={false}
      fields="first_name, last_name,name, email, picture, birthday"
      scope="public_profile, email"
      disabled={btnLoder}
      callback={responseFacebook}
      icon={<i className="fab fa-facebook-f mr-3"></i>}
      textButton={btnLoder ? "Loading..." : "Facebook"}
    />
  );
};

const LoginForm = ({ setSwap, bookDemo, internationalCampaign, pathname }) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const [openSnackbar, closeSnackbar] = useSnackbar();

  const [statusCode, setstatusCode] = useState(0);
  const [numberOremail, setNumberOrEmail] = useState("");
  const [callingCode, setCallingCode] = useState("");

  const [internationalNumber, setInternationalNumber] = useState("");
  const [password, setPassword] = useState("");
  const [errmsg, setErrmsg] = useState("");
  const [field, setField] = useState("");
  const [otp, setOtp] = useState("");
  const [passwordForm, setPasswordForm] = useState(false);
  const [confirmPassword, setConfirmPassword] = useState("");
  const [resendOTP, setResendOTP] = useState(false);
  const [loder, setLoder] = useState(false);
  const [fbloder, setFbLoder] = useState(false);
  const [disabledNumber, setDisabledNumber] = useState(false);
  const user = JSON.parse(localStorage.getItem("DATA"));
  const token = JSON.parse(localStorage.getItem("TOKEN"));
  const time_zone = JSON.parse(localStorage.getItem("TIMEZONE"));

  const influencer_code = localStorage.getItem("INFLUENCER_CODE");
  const utm_code = localStorage.getItem("UTM_CODE");
  const isAddPage = localStorage.getItem("ADD_PAGE");

  useEffect(() => {
    if (token) {
      if(pathname?.from?.pathname=="/courses"){
        history.push("/courses");
        window.location.reload();
      }else{
        history.push("/dashboard");
        window.location.reload();
      }

    }
  }, [])

  console.log(pathname)
  useEffect(() => {
    if (internationalNumber) {
      const userPhoneNumber = parsePhoneNumber(internationalNumber);

      if (userPhoneNumber) {
        if (isValidPhoneNumber(userPhoneNumber.number)) {
          const country_calling_code = getCountryCallingCode(
            userPhoneNumber.country
          );

          setCallingCode("+" + country_calling_code);
          setNumberOrEmail(
            internationalNumber.replace("+" + country_calling_code, "")
          );
        }
      }
    }
  }, [internationalNumber]);

  const checkOtpPassword = (e) => {
    e.preventDefault();
    if (isValidPhoneNumber(internationalNumber)) {
      setLoder(true);
      const data = {
        phoneNumber: numberOremail,
        countryCode: callingCode,
        timezone: time_zone.timezone,
      };
      const onSucess = (msg, code) => {
        setLoder(false);
        setDisabledNumber(true);
        setstatusCode(code);
        if (code === 202) {
          //Signup user
          setErrmsg("Please sign up to create an account")
          openSnackbar("Please sign up to create an account")
          // setLoder(true);
          // const signupData = {
          //   phoneNumber: numberOremail,
          //   notificationid:
          //     "ueiwbascckuqwppwieqwdwdasdksjdlasduwoiuoqieqnkwdasjlihdqwdqwjdlqiwdwdlwdkwd",
          //   isWebsite: true,
          //   countryCode: callingCode,
          //   timezone: time_zone.timezone,
          //   country: time_zone.country,
          //   source:getDevice()
          // };
          // const onSucess = (msg, code) => {
          //   openSnackbar(msg);
          //   setLoder(false);
          //   setDisabledNumber(true);
          //   setstatusCode("showOTP");
          //   setResendOTP(true);

          //   if (bookDemo === "bookDemo") {
          //     var pixelData = {
          //       "Adult website":true
          //     }
          //     ReactPixel.trackCustom("Complete registration",pixelData);
          //   }
          // };
          // const onError = (msg) => {
          //   openSnackbar(msg);
          //   setDisabledNumber(false);
          //   console.log(msg);
          //   setLoder(false);
          // };
          // dispatch(Signup(signupData, onSucess, onError));
        } else if (code === 201) {
          setLoder(false);
          setErrmsg("")
          setstatusCode("showOTP");
          setResendOTP(true);
        }
      };
      const onError = (msg) => {
        console.log(msg);
        setDisabledNumber(false);
        setLoder(false);
      };
      dispatch(AskOtpV1(data, onSucess, onError));
    } else {
      openSnackbar("Invalid Mobile Number");
    }
  };

  const LoginUser = (e) => {
    e.preventDefault();
    setLoder(true);

    const data = {
      phoneNumber: numberOremail,
      password: password,
    };
    const onSucess = (msg) => {
      // makeToast("success", msg);
      console.log(msg);
      setLoder(false);
      localStorage.setItem("LOGIN", JSON.stringify("true"));
      localStorage.setItem("ROLE", JSON.stringify("Learner"));
      localStorage.setItem("IS_LOGOUT", true);
      // localStorage.setItem("LOGIN", JSON.stringify("true"));
      localStorage.setItem("ROLE", JSON.stringify("Learner"));
      localStorage.setItem("USER", JSON.stringify(msg.learner));
      localStorage.setItem("TOKEN", JSON.stringify(msg.learner.token));
      localStorage.setItem("IS_LOGOUT", true);
      localStorage.removeItem("STEP");
      localStorage.removeItem("DATA");
      localStorage.removeItem("NAME");
      openSnackbar("Login successful");
      // history.push("/dashboard");
      // window.location.reload();
      // history.push("/dashboard");
      openSnackbar("successful");
    };
    const onError = (msg) => {
      setField("password");
      setLoder(false);
      setErrmsg(msg);
    };
    dispatch(learnerLogin(data, onSucess, onError));
  };

  const varifyOTP = (e) => {
    e.preventDefault();
    setLoder(true);

    var fromAddPage = isAddPage ? isAddPage : localStorage.getItem("ADD_PAGE")
    var utmCode = utm_code ? utm_code : localStorage.getItem("UTM_CODE")


    var data = {
      OTP: otp,
      timezone: time_zone.timezone,
      phoneNumber: numberOremail
    };
    if (influencer_code && !isAddPage) {
      data["influencer"] = influencer_code;
    }

    if (fromAddPage === true || fromAddPage === "true") {
      data["UTMSource"] = utmCode;
    }

    const onSuccess = (res) => {
      console.log(res);
      openSnackbar(res.data.message);
      setLoder(false);
      if (bookDemo === "bookDemo") {
        var pixelData = {
          "Adult website": true
        }
        ReactPixel.trackCustom("Contact", pixelData);
        // history.push("/dashboard");
        // window.location.reload();
        if (pathname?.from?.pathname == "/courses") {
          console.log("TRUE")
          history.push("/courses");
        } else {
          console.log("False")
          history.push("/dashboard");
          // window.location.reload();
          // history.push("/dashboard");

        }
      } else {
        // setPasswordForm(true);
        openSnackbar(res.data.message);
        setLoder(false);
        localStorage.removeItem("IS_LOGOUT");
        localStorage.setItem("USER", JSON.stringify(res.data.learner));
        localStorage.setItem("TOKEN", JSON.stringify(res.data.learner.token));
        localStorage.setItem("LOGIN", JSON.stringify("true"));
        localStorage.setItem("IS_LOGOUT", JSON.stringify(true));
        localStorage.setItem("ROLE", JSON.stringify("Learner"));

        if (pathname?.from?.pathname == "/courses") {
          console.log("TRUE")
          history.push("/courses");
        } else {
          console.log("False")
          history.push("/dashboard");
          // window.location.reload();
          // history.push("/dashboard");

        }
      }
    };
    const onError = (msg) => {
      setField("otp");
      openSnackbar(msg);
      setLoder(false);
      setErrmsg(msg);
    };

    if (bookDemo === "bookDemo") {
      dispatch(VerifyOtpV1(data, onSuccess, onError, true));
    } else {
      dispatch(VerifyOtpV1(data, onSuccess, onError));
    }

  };

  const updatePassword = (e) => {
    e.preventDefault();
    setLoder(true);
    if (password === confirmPassword) {
      const data = {
        phoneNumber_: numberOremail,
        password_: password,
      };

      const onSuccess = (msg) => {
        setLoder(false);
        console.log(msg);
        openSnackbar(msg);
        localStorage.removeItem("IS_LOGOUT");
        localStorage.setItem("USER", JSON.stringify(user));
        localStorage.setItem("TOKEN", JSON.stringify(user.token));
        localStorage.setItem("LOGIN", JSON.stringify("true"));
        localStorage.setItem("IS_LOGOUT", JSON.stringify(true));
        localStorage.setItem("ROLE", JSON.stringify("Learner"));

        history.push("/dashboard");
        window.location.reload();
        history.push("/dashboard");


      };
      const onError = (msg) => {
        setLoder(false);
        openSnackbar(msg);
        console.log(msg);
      };
      dispatch(Setpassword(data, onSuccess, onError));
    } else if (password != confirmPassword) {
      alert("Passwords don't match");
      setLoder(false);
    }
  };

  //RESEND OTP COUNTER
  useEffect(() => {
    if (resendOTP) {
      var timeLeft = 40;
      var elem = document.getElementById("some_div");
      var timerId = setInterval(countdown, 1000);

      function countdown() {
        if (timeLeft === -1) {
          clearTimeout(timerId);
          setResendOTP(false);
        } else {
          elem.innerHTML = `Resend OTP (${timeLeft})`;
          timeLeft--;
        }
      }
    }
  }, [resendOTP]);

  const resendOtp = () => {
    // ResendOtp
    if (numberOremail) {
      const data = {
        phoneNumber: numberOremail,
      };
      const onSuccess = () => {
        openSnackbar("OTP send Successfully");
      };

      const onError = (msg) => {
        openSnackbar(msg);
      };
      dispatch(ResendOtpV1(data, onSuccess, onError));
    } else {
      openSnackbar("Please Enter Phone number or Email");
    }
  };

  //login or signup with facebook
  const responseFacebook = (response) => {
    console.log(response)
    setFbLoder(true);

    var fromAddPage = isAddPage ? isAddPage : localStorage.getItem("ADD_PAGE")
    var utmCode = utm_code ? utm_code : localStorage.getItem("UTM_CODE")


    if (response.email) {
      const data = {
        email: response.email,
        authType: "facebook",
        isWebsite: true,
        notificationid: "iiuiusdiwdwydqw18302802ue21he28e2eeoiwd9h09809iy",
      };

      if (fromAddPage === true || fromAddPage === "true") {
        data["UTMSource"] = utmCode;
      }

      const onSuccess = (data) => {
        openSnackbar(data.message);
        console.log(data.message);
        if (bookDemo === "bookDemo") {
          var pixelData = {
            "Email": response.email,
            "Adult website": true
          }
          ReactPixel.trackCustom("Complete registration", pixelData);
        }
        setFbLoder(false);
        if (pathname?.from?.pathname == "/courses") {
          console.log("TRUE")
          history.push("/courses");
        } else {
          console.log("False")
          history.push("/dashboard");
          // window.location.reload();
          // history.push("/dashboard");

        }

      };
      const onError = (message) => {
        console.log(message);
        setFbLoder(false);
        openSnackbar(message);
      };
      dispatch(SosialAuth(data, onSuccess, onError));
    } else {
      openSnackbar(
        "Your account is not applicable for Facebook login. please link your email with Facebook"
      );
    }
  };

  // GoogleLogin
  const responseGoogle = (response) => {
    console.log(response);

    var fromAddPage = isAddPage ? isAddPage : localStorage.getItem("ADD_PAGE")
    var utmCode = utm_code ? utm_code : localStorage.getItem("UTM_CODE")

    if (response?.profileObj?.email) {
      console.log(isAddPage)
      const data = {
        email: response?.profileObj?.email,
        authType: "google",
        isWebsite: true,
        notificationid: "iiuiusdiwdwydqw18302802ue21he28e2eeoiwd9h09809iy"
      };

      if (fromAddPage === true || fromAddPage === "true") {
        data["UTMSource"] = utmCode;
      }

      const onSuccess = (message) => {
        if (bookDemo === "bookDemo") {
          var pixelData = {
            "Email": response?.profileObj?.email,
            "Adult website": true
          }
          ReactPixel.track("Complete registration", pixelData);
        }
        localStorage.setItem("IS_LOGOUT", true);
        if (pathname?.from?.pathname == "/courses") {
          console.log("TRUE")
          history.push("/courses");
        } else {
          console.log("False")
          history.push("/dashboard");
          // window.location.reload();
          // history.push("/dashboard");

        }
        // history.push("/dashboard");
        // window.location.reload();
        // history.push("/dashboard");

      };
      const onError = (message) => {
        console.log(message);
        openSnackbar(message);
      };

      dispatch(SosialAuth(data, onSuccess, onError));

    }
  }



  return (
    <div className="ml-4">
      {!passwordForm ? (
        <form
          className="text-center "
          onSubmit={
            statusCode == 200
              ? (e) => LoginUser(e)
              : statusCode === "showOTP"
                ? (e) => varifyOTP(e)
                : (e) => checkOtpPassword(e)
          }
        >
          <div className={`login-body text-left ${bookDemo ? "mx-auto" : ""}`}>
            <h1 className=" modal_header_title">
              {statusCode === "showOTP"
                ? "Verify OTP"
                : statusCode == 200
                  ? "Login with Phone Number"
                  : bookDemo
                    ? "Book a trial 😄"
                    : "Welcome, Learner!"}
            </h1>
            <p className="text-left ">Log in with:</p>
            <div className="text-left d-flex ">
              <div className="mr-2">
                <FacebookAuth
                  responseFacebook={responseFacebook}
                  onClick={() => setFbLoder(true)}
                  btnLoder={fbloder}
                />
              </div>
              <div className="ml">
                <GoogleLogin
                  className="googlelogin pl-3"
                  clientId="588700685831-3g24qaneuum1hh5rdgld0gft4jdc3uo1.apps.googleusercontent.com"
                  buttonText="Google"
                  onSuccess={responseGoogle}
                  onFailure={responseGoogle}
                  cookiePolicy={'single_host_origin'}

                />
              </div>
            </div>
            {time_zone.timezone == "Asia/Calcutta" || time_zone.timezone == "Asia/Kolkata" ?

              <p className="line text-center mt-2">or</p> : ""}

            {/* conditionally showing log screen based on national or international timezones */}

            {time_zone.timezone == "Asia/Calcutta" || time_zone.timezone == "Asia/Kolkata" ?
              <div className="form-group">
                <p className="text-left ">Phone Number:</p>
                <PhoneInput
                  style={{ borderRadius: "5px" }}
                  placeholder="Enter Mobile number"
                  className="input inp mt-3 "
                  international
                  countryCallingCodeEditable={false}
                  defaultCountry={time_zone.country}
                  // country={time_zone.country}
                  value={internationalNumber}
                  onChange={setInternationalNumber}
                // disabled={disabledNumber}
                />

                {statusCode === 200 ? (
                  <>
                    <input
                      id="pword"
                      className={`input  ml-md-2 mt-3 ${field === "password" ? "invalid_input" : ""
                        }`}
                      placeholder="Password"
                      type="password"
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                      required
                    />
                    <label className="invalid_message"></label>
                    {field === "password" ? (
                      <label className="invalid_message ">{errmsg}</label>
                    ) : (
                      ""
                    )}
                    <div style={{ width: "90%" }}>
                      <p
                        id="forgotpassid"
                        className="text-right"
                        style={{ cursor: "pointer" }}
                        onClick={() => setSwap("forgotpassword")}
                      >
                        Forgot password ?
                      </p>
                    </div>
                  </>
                ) : statusCode === 201 || statusCode === "showOTP" ? (
                  <>
                    {/* <input
                      className="input mt-3 ml-1"
                      placeholder="6-digit OTP"
                      type="number"
                      value={otp}
                      onChange={(e) => setOtp(e.target.value)}
                      required
                    /> */}
                    <div className="otp-wrap">
                      <OTPInput className="otp-style  mt-3  mb-0 pb-0 " value={otp} onChange={setOtp} autoFocus OTPLength={6} otpType="number" disabled={false} />

                      {resendOTP ? (
                        <p
                          className="text-danger mr-5 mt-1"
                          id="some_div"
                          style={{ textAlign: "right" }}
                        ></p>
                      ) : (
                        <p
                          style={{ textAlign: "right", cursor: "pointer" }}
                          onClick={() => {
                            setResendOTP(true);
                            resendOtp();
                          }}
                          className="mr-5 mt-0"
                        >
                          Resend OTP ?
                        </p>
                      )}
                    </div>
                    {/* <ResendOTP onResendClick={() => console.log("Resend clicked")} /> */}

                    {/* <label className="invalid_message"></label> */}
                    {/* <br /> */}
                    {field === "otp" ? (
                      <label className="invalid_message ">{errmsg}</label>
                    ) : (
                      ""
                    )}
                    {/* <br /> */}

                  </>
                ) : (
                  <></>
                )}
                <div className="text-left ">
                  <button

                    type="submit"
                    disabled={loder ? true : false}
                    className={
                      loder ? "continueBTNdisabled ml-md-0" : "continueBTN ml-md-0"
                    }
                  >
                    {loder ? "Loading ..." : "Continue"}
                  </button>
                </div>

                {/* <label className="invalid_message ">{errmsg}</label> */}

              </div>
              :
              ""}


            {bookDemo && internationalCampaign ? (
              ""
            ) : (
              <>
                {/* {time_zone.timezone == "Asia/Calcutta" || time_zone.timezone == "Asia/Kolkata" ?
                  <p className="line">or</p> : ""}


                <div >

                  <FacebookAuth
                    responseFacebook={responseFacebook}
                    onClick={() => setFbLoder(true)}
                    btnLoder={fbloder}
                  />
                </div> */}



                <div className="text-left mt-2">
                  {/* {time_zone.timezone === "Asia/Calcutta" || time_zone.timezone === "Asia/Kolkata" ?
                    "" :
                    <GoogleLogin
                      className="googlelogin pl-3"
                      clientId="588700685831-3g24qaneuum1hh5rdgld0gft4jdc3uo1.apps.googleusercontent.com"
                      buttonText="Google"
                      onSuccess={responseGoogle}
                      onFailure={responseGoogle}
                      cookiePolicy={'single_host_origin'}
                    />
                  } */}
                  {
                    bookDemo ? "" :
                      <div>
                        <p className="tc "><small>By continuing with login or signup, you agree to Clapingo's <a target="_blank" href="https://clapngobucket.s3.amazonaws.com/documents/misc/policy_and_terms.pdf" className="booknow mx-auto">Terms & Conditions</a></small></p>
                      </div>
                  }

                </div>

              </>
            )}
          </div>
        </form>
      ) : (
        <form className="text-center" onSubmit={(e) => updatePassword(e)}>

          <div className={`login-body ${bookDemo ? "mx-auto" : ""}`}>

            <h1 className="text-left modal_header_title ml-md-5">
              Set your password
            </h1>
            <div class="form-group">
              <input
                id="setpassid"
                className="input mt-3"
                id="password"
                placeholder="Password"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />

              <input
                id="conformpassword"
                className="input mt-3"
                placeholder="Confirm Password"
                type="password"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                required
              />

              <button
                type="submit"
                disabled={loder ? true : false}
                className={loder ? "continueBTNdisabled" : "continueBTN"}
              >
                {loder ? "Loading ..." : "Continue"}
              </button>
            </div>
            {bookDemo && internationalCampaign ? (
              ""
            ) : (
              <>
                <p className="line">or</p>

                <div class="options">
                  <FacebookAuth
                    responseFacebook={responseFacebook}
                    onClick={() => setFbLoder(true)}
                    btnLoder={fbloder}
                  />
                </div>
              </>
            )}
          </div>
        </form>
      )}
    </div>
  );
};

export default LoginForm;